import { WidgetInstance } from "friendly-challenge";

// HTML FriendlyCaptcha
// add HTML-Field with this code to Ninja Form:
// <div id="friendlycaptcha-widget" class="frc-captcha" data-sitekey="FCMJJTRCL1SSHI3C" data-lang="de"></div>

jQuery(document).ready(function($) {

  $.friendlycaptcha = {

    init: function() {
      // check if ninja form exists
      const form = document.querySelector('.nf-form-cont')

      if (form) {
        let interval = setInterval(function() {
          // load widget as soon as #friendlycaptcha-widget found
          const friendlycaptcha = document.querySelector('#friendlycaptcha-widget')

          if (friendlycaptcha) {
            clearInterval(interval)

            // disable submit button
            form.querySelector('input.ninja-forms-field[type="submit"]').setAttribute('disabled', true)

            $.friendlycaptcha.load()
          }
        }, 1);
      }
    },

    load: function() {

      function doneCallback(solution) {
        // enable submit button
        const form = document.querySelector('.nf-form-cont')
        form.querySelector('input.ninja-forms-field[type="submit"]').removeAttribute('disabled')

        // console.log('Captcha was solved. The form can be submitted.')
        // console.log(solution)
      }

      function errorCallback(err) {
        // console.log('There was an error when trying to solve the Captcha.')
        // console.log(err)
      }

      const element = document.querySelector('#friendlycaptcha-widget')
      const options = {
        doneCallback: doneCallback,
        errorCallback: errorCallback,
        sitekey: 'FCMJJTRCL1SSHI3C'
      }

      const widget = new WidgetInstance(element, options)

      // verification starts automatically when widget is loaded
      // widget.start()      
    }
  }

});
